import styled from 'styled-components';

const SeverityName = styled.span`
margin-left: 7px;
`;
SeverityName.displayName = 'SeverityName';

export default SeverityName;
